import * as React from "react";

export default class Login extends React.Component {
  render() {
    return <div className="login" />;
  }
}
